import script from "./SessionList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SessionList.vue?vue&type=script&lang=ts&setup=true"

import "./SessionList.vue?vue&type=style&index=0&id=5a0ac1c0&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0ac1c0"]])

export default __exports__